import { c as _c } from "react/compiler-runtime";
import { Fragment } from "react";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import GroupsSidebar from "./GroupsSidebar";
export default function GroupsSidebarApp(t0) {
  const $ = _c(12);
  const {
    open,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <XMarkIcon className="tw-w-7 tw-h-7 tw-flex-shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <div className="tw-flex tw-items-center tw-justify-end tw-px-4 tw-mb-2"><button type="button" aria-label="Close sidebar" className="tw-text-iron-300 tw-transition-colors tw-duration-200 tw-bg-iron-950 tw-border-0 tw-rounded-full tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center" onClick={onClose}>{t1}</button></div>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <nav className="tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 tw-px-4"><GroupsSidebar /></nav>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="tw-fixed tw-inset-0 tw-flex tw-items-end"><TransitionChild as={Fragment} enter="tw-transform tw-ease-out tw-duration-[225ms]" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-ease-in tw-duration-[195ms]" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><DialogPanel className="tw-pointer-events-auto tw-w-full tw-h-screen tw-bg-iron-950 tw-shadow-xl tw-flex tw-flex-col tw-rounded-t-2xl tw-pb-[env(safe-area-inset-bottom,0px)] tw-pt-[env(safe-area-inset-top,0px)]">{t2}{t3}</DialogPanel></TransitionChild></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onClose || $[7] !== t4) {
    t5 = <Dialog as="div" className="tw-fixed tw-inset-0 tw-z-[1010] tw-overflow-hidden tailwind-scope" onClose={onClose}>{t4}</Dialog>;
    $[6] = onClose;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== open || $[10] !== t5) {
    t6 = <Transition appear={true} show={open} as={Fragment}>{t5}</Transition>;
    $[9] = open;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}